import { useEffect, useState, useContext } from "react";
import { useUser } from "../../context/user";
import algoliasearch from "algoliasearch/lite";
import { InstantSearch, Hits, Configure } from "react-instantsearch-hooks-web";
import ProductCard from "../../components/product/ProductCard";
import styles from "./favorites.module.scss";
import StoreContext from "../../context/store";
import Link from "next/link";
import Header from "../../components/shop/Header";
import { remove } from "nprogress";

const searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_KEY
);

const indexName = "menu-products-by-rating-production";

export default function FavoritesPage() {
  const { userData, isAuthenticated, favoriteQuantity } = useUser();
  const { store } = useContext(StoreContext);
  const [productIds, setProductIds] = useState([]);

  const updateFavorites = () => {
    if (isAuthenticated) {
      const userFavorites = userData?.product_content?.product_favorites?.map(
        (fav) => fav.product_id
      ) || [];
      setProductIds(userFavorites);
    } else {
      const localFavorites = JSON.parse(localStorage.getItem("favorites") || "[]");
      setProductIds(localFavorites.map((fav) => fav.productId));
    }
  };

  useEffect(() => {
    updateFavorites();
    console.log("Favorites updated");
  }, [isAuthenticated, userData]);

  return (
    <>
      <Header category="favorites" />
      <div className="container">
        {!isAuthenticated && (
          <div className={styles.warning}>
            <p>
              You are not logged in! Your favorites will be saved to your browser&apos;s local storage.
              To save your favorites indefinitely, please <Link href="/login">sign up or login.</Link>
            </p>
          </div>
        )}
        {productIds.length > 0 ? (
          <InstantSearch searchClient={searchClient} indexName={indexName}>
            <Configure filters={`product_id:${productIds.join(" OR product_id:")} AND store_id:${store}`} />
            <div className="shop-product-grid mt-1 mb-1">
              <Hits hitComponent={ProductCard} />
            </div>
          </InstantSearch>
        ) : (
          <div className="flex center pb-4 pt-4 text-center balance">
            <p>
              You have not favorited any products. <Link href="/shop" className="link">Add some products to get started</Link>.
            </p>
          </div>
        )}
      </div>
    </>
  );
}
